<template>
 <div class="loading-indicator">
      <div class="loading-indicator__content">
        <div class="bb-spinner">
          <div class="bb-spiner__content">
            <div class="bb-spinner__dots">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div class="bb-spinner__title">
              Loading
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import axios from "axios";
import Vue from 'vue';

export default {
  name: "LoginAppBridge",
  async mounted() {
    console.log("LoginAppBridge mounted");
    // Aquí puedes agregar la lógica para comunicarte con el login-app
    await this.$store.dispatch("clearSiteData");

    var token = this.$route.query.auth_token;
    var destination = this.$route.query.page || "/mi-lista";
    if (token) {
      let response
      try {
          // eslint-disable-next-line no-undef
          response = await axios.post("/login-app", {
            token: token
          });
      } catch (error) {
          return error.response.status
      }

      const user = response.data;
      if (user) {
        // guardar usuari logat i token a vuex
        this.$store.commit("setUser", user);
        if(user.name) this.$store.commit("setLoginNoName", false);

        this.$forceRefreshState();

        this.$i18n.locale = this.preferredLanguage;

        //add sourceApp cookie
        document.cookie = "sourceApp=true; path=/; max-age=" + 60 * 60 * 24 * 360; //30 days
        //this.$store.state.cookies.sourceApp = true;
        Vue.set(this.$store.state.cookies, 'sourceApp', 'true');
        Vue.set(this.$store.state.cookies, 'cookie_consent_user_accepted', "true");

        await this.$router.replace(destination);
      }
    }
  },
};
</script>
